import { createSlice } from '@reduxjs/toolkit';
import { getJSONFromHtml } from '../../../../domain/common';
import { ISiteHeaderAccountItem } from '../interfaces';
import { getPersonalizationProperty } from '../../../personalization/domain/personalization-provider';

interface IState {
    columns: ISiteHeaderAccountItem[][];
    isOpened: boolean;
    isLoggedIn: boolean;
    userName: string;
    showNewUserPopup: boolean;
    isLoading: boolean;

    // https://wavesaudio.atlassian.net/browse/DSWEB-4467
    userHasSbsPaymentIssue: boolean;
}

/**
 * initial state
 */
const initialState: IState = {
    columns: getJSONFromHtml(document.getElementById('site-header-top-account-json')) || [],
    isOpened: false,
    isLoggedIn: false,
    userName: '',
    showNewUserPopup: false,
    isLoading: true,

    // https://wavesaudio.atlassian.net/browse/DSWEB-4467
    userHasSbsPaymentIssue: getPersonalizationProperty('hasSBSPaymentIssue') as boolean,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;